const BLOCKS_TO_CHECK = [
    "block-start",
    "block-end",
    "inline-caption",
    "stretch-start",
    "stretch-end"
];
const containsActionTypeActions = (action, additionalItems) => {
    if (additionalItems == null) {
        return false;
    }
    return additionalItems.some(additionalItem => additionalItem.action &&
        additionalItem.action.type === action);
};
const isActionTypeBlock = (action, section, additionalModel) => {
    if (additionalModel == null) {
        return undefined;
    }
    let editingBlockInfo;
    if (containsActionTypeActions(action, additionalModel.start)) {
        editingBlockInfo = { section: section, align: ["start"] };
    }
    if (containsActionTypeActions(action, additionalModel.center)) {
        if (editingBlockInfo) {
            editingBlockInfo.align.push("center");
        }
        else {
            editingBlockInfo = { section: section, align: ["center"] };
        }
    }
    if (containsActionTypeActions(action, additionalModel.end)) {
        if (editingBlockInfo) {
            editingBlockInfo.align.push("end");
        }
        else {
            editingBlockInfo = { section: section, align: ["end"] };
        }
    }
    return editingBlockInfo;
};
export const computeActionTypeBlocks = (action, additionalInfo) => {
    if (additionalInfo == null) {
        return undefined;
    }
    let editingBlocks = undefined;
    BLOCKS_TO_CHECK.forEach(block => {
        const editingBlock = isActionTypeBlock(action, block, additionalInfo[block]);
        if (editingBlock) {
            editingBlocks ??= [];
            editingBlocks.push(editingBlock);
        }
    });
    return editingBlocks;
};
